
  import { Vue, Component, Prop, Emit } from "vue-property-decorator";
  import { getModule } from "vuex-module-decorators";
  import TheSearchbar from "./TheSearcbar.vue";
  import { ISearchBarViewModel, IUserModel } from "@/models";
  import { UserService } from "@/services";
  import { Auth } from "@/store/modules/AuthModule";
  import { WebAgent } from "@/helper";
  import store from "@/store";

  const AuthModule = getModule(Auth, store);

  @Component({
    name: "TheNavbar",
    components: { TheSearchbar }
  })
  export default class TheNavBar extends Vue {
    visible: boolean = true;
    // expanded: boolean = false;
    publicPath: string = process.env.BASE_URL as string;

    @Prop()
    searchParams!: ISearchBarViewModel;

    get fullname() {
      if (this.isLogin === true) {
        const { firstName } = AuthModule.currentUser as IUserModel;
        return `Hi, ${firstName}`;
      }
      return "";
    }

    get isLogin() {
      return AuthModule.isAuthenticated;
    }
    
    get isAdmin() {
     let isAdmin = false;
      switch (window.location.host) {
        case "qa.vin.com":
          isAdmin = false;
          break;
        case "www.vin.com":
          isAdmin = false;
          break;
        default:
          isAdmin = AuthModule.isAdmin;
          break;
      }
      return isAdmin;
    }

    get searchOptions(): ISearchBarViewModel {
      if (this.searchParams === undefined) {
        return {
          category: -1,
          state: -1,
          date: -1,
          searchText: ""
        };
      }
      return Object.assign({}, this.searchParams);
    }

    @Emit("onSearchFormChange")
    onSearchFormChange() {
      // empty function
      // do nothing
    }

    onSearchChange() {
      this.onSearchFormChange();
    }

    getImagePath(path: string) {
      return `${this.publicPath}${path}`;
    }

    async handleLogout() {
      this.$mainLoader.show();
      await UserService.Logout();
      AuthModule.logout();
      setTimeout(() => {
        if (process.env.NODE_ENV === "production") {
          const cookies = this.$cookies.keys();
          cookies.forEach(key => {
            if (WebAgent.IsInternetExplore()) {
              this.$cookies.set(key, "", 0);
            } else {
              this.$cookies.remove(key);
              this.$cookies.remove(key, "/", ".vin.com");
            }
          });
        }
        this.$mainLoader.hide();
        if (WebAgent.IsInternetExplore()) {
          window.history.pushState("", "", this.publicPath);
          window.location.reload(true);
        } else {
          window.location.replace(this.publicPath);
        }
      }, 500);
    }

    get isMobileView() {
      return WebAgent.IsMobile();
    }
  }
